import { FC } from 'react';

import UShapeNorth from '../../../../../../../assets/icons/shapes/u-shape/u-shape-1.svg?react';
import UShapeEast from '../../../../../../../assets/icons/shapes/u-shape/u-shape-2.svg?react';
import UShapeSouth from '../../../../../../../assets/icons/shapes/u-shape/u-shape-3.svg?react';
import UShapeWest from '../../../../../../../assets/icons/shapes/u-shape/u-shape-4.svg?react';
import { Himmelretning } from '../../../../../utils/registerEnums';

import { ShapeProps } from './types';

export const UShape: FC<ShapeProps> = ({ direction }) => {
  switch (direction) {
    case Himmelretning.Nord:
      return <UShapeNorth />;
    case Himmelretning.Ost:
      return <UShapeEast />;
    case Himmelretning.Sor:
      return <UShapeSouth />;
    case Himmelretning.Vest:
      return <UShapeWest />;

    default:
      return <UShapeNorth />;
  }
};
